export interface MenuItem {
  id: string
  label: string
  labelId?: string
  description?: string
  descriptionId?: string
  submenus?: MenuItem[]
  predefinedMessage?: string
  predefinedMessageId?: string
  isLeaf?: boolean
}

export const MAIN_MENU: MenuItem[] = [
  {
    id: 'faq',
    label: 'FAQs',
    labelId: 'CHATBOT.MENU.FAQ_LABEL',
    description: 'Frequently Asked Questions',
    descriptionId: 'CHATBOT.MENU.FAQ_DESCRIPTION',
    predefinedMessageId: 'CHATBOT.MENU.FAQ_MESSAGE',
    isLeaf: true,
  },
  {
    id: 'manual',
    label: 'User Manual',
    labelId: 'CHATBOT.MENU.MANUAL_LABEL',
    description: 'Learn how to use the system',
    descriptionId: 'CHATBOT.MENU.MANUAL_DESCRIPTION',

    predefinedMessageId: 'CHATBOT.MENU.MANUAL_MESSAGE',
    isLeaf: true,
  },
  {
    id: 'walkthrough',
    label: 'Walkthrough',
    labelId: 'CHATBOT.MENU.WALKTHROUGH_LABEL',
    description: 'Step-by-step instructions and walkthroughs',
    descriptionId: 'CHATBOT.MENU.WALKTHROUGH_DESCRIPTION',

    predefinedMessageId: 'CHATBOT.MENU.WALKTHROUGH_MESSAGE',
    submenus: [
      {
        id: 'walkthrough.timetable',
        label: 'Timetable Walkthrough',
        labelId: 'CHATBOT.MENU.WALKTHROUGH_TIMETABLE_LABEL',
        description: 'Step-by-step walkthrough for timetable features',
        descriptionId: 'CHATBOT.MENU.WALKTHROUGH_TIMETABLE_DESCRIPTION',
        isLeaf: true,
      },
    ],
  },
  {
    id: 'attendance',
    label: 'Attendance',
    labelId: 'CHATBOT.MENU.ATTENDANCE_LABEL',
    description: 'Attendance-related queries',
    descriptionId: 'CHATBOT.MENU.ATTENDANCE_DESCRIPTION',
    submenus: [
      {
        id: 'attendance.records',
        label: 'View Records',
        labelId: 'CHATBOT.MENU.ATTENDANCE_RECORDS_LABEL',
        description: 'Check attendance records',
        descriptionId: 'CHATBOT.MENU.ATTENDANCE_RECORDS_DESCRIPTION',
        isLeaf: true,
      },
      {
        id: 'attendance.stats',
        label: 'Attendance Stats',
        labelId: 'CHATBOT.MENU.ATTENDANCE_STATS_LABEL',
        description: 'View attendance statistics',
        descriptionId: 'CHATBOT.MENU.ATTENDANCE_STATS_DESCRIPTION',
        isLeaf: true,
      },
    ],
  },
]

export const MENU_TO_BOARD_MAP: Record<string, {type: string; board: string; subType: string}> = {
  faq: {type: 'document', board: 'document-context', subType: 'faq'},
  manual: {type: 'document', board: 'document-context', subType: 'manual'},
  walkthrough: {
    type: 'document',
    board: 'document-context',
    subType: 'walkthrough',
  },
  'walkthrough.timetable': {
    type: 'document',
    board: 'document-context',
    subType: 'walkthrough.timetable',
  },
  attendance: {
    type: 'database',
    board: 'attendance-query',
    subType: 'attendance',
  },
  'attendance.records': {
    type: 'database',
    board: 'attendance-query',
    subType: 'attendance.records',
  },
  'attendance.stats': {
    type: 'database',
    board: 'attendance-query',
    subType: 'attendance.stats',
  },
}

export default MAIN_MENU
